import { render, staticRenderFns } from "./ResetPasswordDo.vue?vue&type=template&id=1042f90f&scoped=true&"
import script from "./ResetPasswordDo.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordDo.vue?vue&type=script&lang=js&"
import style0 from "./ResetPasswordDo.vue?vue&type=style&index=0&id=1042f90f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1042f90f",
  null
  
)

export default component.exports